import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {TRIGGER_SCHEMA_QUERY_KEY} from "../queryKeys";
import {TriggerSchema} from "./types";

type Variables = {};

const getTriggerSchema = async (): Promise<TriggerSchema> => {
  const response = await axiosReachInstance.get<TriggerSchema, AxiosResponse<TriggerSchema>>("/triggers/schema");
  return response.data;
};

export const useGetTriggerSchema = (
  variables: Variables = {},
  options?: BaseQueryOptions<TriggerSchema, Variables>
): BaseUseQueryResult<TriggerSchema> => {
  return useBaseQuery<TriggerSchema, Variables>([TRIGGER_SCHEMA_QUERY_KEY], getTriggerSchema, variables, options);
};
